// Cine ești: contul curent, cerut o singură dată și ținut aici.
//
// Sesiunea trăiește într-un cookie `httponly`, deci JavaScript-ul nu poate citi tokenul —
// singurul mod de a afla cine ești e să întrebi serverul. De aceea starea se încarcă la
// pornire și se împrospătează după intrare, ieșire sau schimbarea profilului.

import { bus } from './util.js';

const json = async (path, body = null) => {
  const resp = await fetch(path, body
    ? { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }
    : {});
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) throw new Error(data.detail || `Ошибка ${resp.status}`);
  return data;
};

class Session {
  user = null;
  /** Nu există încă niciun cont — primul formular arată «înregistrare». */
  empty = true;
  /** Serverul chiar poate trimite e-mailuri? Dacă nu, nu promitem scrisori. */
  mailConfigured = false;
  unread = 0;

  async load() {
    try {
      const data = await json('/api/community/me');
      this.user = data.user;
      this.empty = data.empty;
      this.mailConfigured = !!data.mail_configured;
      this.unread = data.unread || 0;
    } catch {
      this.user = null;
    }
    bus.emit('session:change', this.user);
    return this.user;
  }

  get authenticated() {
    return !!this.user;
  }

  async register(username, email, password) {
    const data = await json('/api/community/register', { username, email, password });
    this.user = data.user;
    this.empty = false;
    bus.emit('session:change', this.user);
    return this.user;
  }

  async login(username, password) {
    const data = await json('/api/community/login', { username, password });
    this.user = data.user;
    bus.emit('session:change', this.user);
    return this.user;
  }

  async logout() {
    // Memoria de sesiune se goleste inaintea iesirii: altfel urmatorul care intra pe
    // acelasi calculator ar vedea o clipa lenta si profilul celui dinainte.
    (await import('./cache.js')).uita();
    await json('/api/community/logout', {});
    this.user = null;
    bus.emit('session:change', null);
  }

  /** Cere un link de recuperare. Răspunsul e același și dacă adresa nu există. */
  async forgot(email) {
    return json('/api/community/forgot', { email: String(email || '').trim() });
  }

  async resetPassword(token, password) {
    return json('/api/community/reset', { token, password });
  }

  async confirm(token) {
    const data = await json('/api/community/confirm', { token });
    await this.load();
    return data.user;
  }

  async resend() {
    return json('/api/community/resend', {});
  }

  /** Schimbarea parolei închide toate sesiunile, inclusiv pe a noastră. */
  async changePassword(oldPass, newPass) {
    await json('/api/community/password', { old: oldPass, new: newPass });
    this.user = null;
    bus.emit('session:change', null);
  }

  async saveAvatar(avatar) {
    const data = await json('/api/community/avatar', { avatar });
    this.user = data.user;
    bus.emit('session:change', this.user);
    return this.user;
  }

  async saveCover(cover) {
    const data = await json('/api/community/cover', { cover });
    this.user = data.user;
    bus.emit('session:change', this.user);
    return this.user;
  }

  async saveProfile(bio) {
    const data = await json('/api/community/profile', { bio });
    this.user = data.user;
    bus.emit('session:change', this.user);
    return this.user;
  }
}

export const session = new Session();

/** Inițialele pentru avatar: două litere din nick, ca la ei. */
export function initials(username) {
  return (username || '?').slice(0, 2).toUpperCase();
}
